import script from "./QrTotem.vue?vue&type=script&setup=true&lang=js"
export * from "./QrTotem.vue?vue&type=script&setup=true&lang=js"

import "./QrTotem.vue?vue&type=style&index=0&id=10d05b76&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d05b76"]])

export default __exports__